import React, { createContext, useCallback, useContext, useState } from 'react';
import Snackbar from '../Snackbar/Snackbar';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const show = useCallback((message, severity) => {
    setToast({ message, severity });
  }, []);

  return (
    <ToastContext.Provider value={show}>
      {children}
      <Snackbar
        open={!!toast}
        autoHideDuration={2400}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        severity={toast?.severity}
        message={toast?.message || ''}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const show = useContext(ToastContext);
  if (!show) throw new Error('useToast must be used within a ToastProvider');

  const flash = useCallback(
    (msg) => show(msg, 'success'),
    [show]
  );

  const flashError = useCallback(
    (e) => show(
      typeof e === 'string' ? e : (e?.message || 'Request failed. Please try again.'),
      'error'
    ),
    [show]
  );

  return { flash, flashError };
};
